import React, { useState, useMemo, useEffect, useRef, useCallback, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';
import '../../css/chats/EmojiPicker.css';

/**
 * Кураторская подборка эмодзи, организованная по категориям.
 * Включает наиболее популярные эмодзи для общения в чате.
 */
const EMOJI_CATEGORIES = {
    smileys: {
        label: 'Смайлы',
        icon: '😀',
        emojis: [
            '😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😂', '🙂', '🙃',
            '😉', '😊', '😇', '🥰', '😍', '🤩', '😘', '😗', '☺️', '😚',
            '😙', '🥲', '😋', '😛', '😜', '🤪', '😝', '🤑', '🤗', '🤭',
            '🤫', '🤔', '🤐', '🤨', '😐', '😑', '😶', '😏', '😒', '🙄',
            '😬', '😮‍💨', '🤥', '😌', '😔', '😪', '🤤', '😴', '😷', '🤒',
            '🤕', '🤢', '🤮', '🤧', '🥵', '🥶', '🥴', '😵', '🤯', '🤠',
            '🥳', '🥸', '😎', '🤓', '🧐', '😕', '😟', '🙁', '☹️', '😮',
            '😯', '😲', '😳', '🥺', '😦', '😧', '😨', '😰', '😥', '😢',
            '😭', '😱', '😖', '😣', '😞', '😓', '😩', '😫', '🥱', '😤',
            '😡', '😠', '🤬', '😈', '👿', '💀', '☠️', '💩', '🤡', '👹',
            '👺', '👻', '👽', '🤖', '😺', '😸', '😹', '😻', '😼', '😽',
            '🙀', '😿', '😾',
        ],
    },
    gestures: {
        label: 'Жесты',
        icon: '👍',
        emojis: [
            '👍', '👎', '👌', '🤌', '🤏', '✌️', '🤞', '🤟', '🤘', '🤙',
            '👈', '👉', '👆', '👇', '☝️', '👋', '🤚', '🖐️', '✋', '🖖',
            '👏', '🙌', '👐', '🤲', '🤝', '🙏', '✍️', '💪', '🦾', '🦿',
            '🦵', '🦶', '👂', '🦻', '👃', '🧠', '🫀', '🫁', '🦷', '🦴',
            '👀', '👁️', '👅', '👄', '💋', '🫦', '🦵', '🦶', '👣',
        ],
    },
    hearts: {
        label: 'Сердца',
        icon: '❤️',
        emojis: [
            '❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '🤍', '🤎', '💔',
            '❣️', '💕', '💞', '💓', '💗', '💖', '💘', '💝', '💟', '💌',
            '💍', '💎', '🔥', '💯', '💢', '💥', '💫', '💦', '💨', '🕳️',
            '💣', '💬', '👁️‍🗨️', '🗨️', '🗯️', '💭', '💤',
        ],
    },
    animals: {
        label: 'Животные',
        icon: '🐶',
        emojis: [
            '🐶', '🐱', '🐭', '🐹', '🐰', '🦊', '🐻', '🐼', '🐨', '🐯',
            '🦁', '🐮', '🐷', '🐸', '🐵', '🙈', '🙉', '🙊', '🐔', '🐧',
            '🐦', '🐤', '🐣', '🐥', '🦆', '🦅', '🦉', '🦇', '🐺', '🐗',
            '🐴', '🦄', '🐝', '🐛', '🦋', '🐌', '🐞', '🐜', '🦗', '🕷️',
            '🦂', '🐢', '🐍', '🦎', '🦖', '🦕', '🐙', '🦑', '🦐', '🦞',
            '🦀', '🐡', '🐠', '🐟', '🐬', '🐳', '🐋', '🦈', '🐊', '🐅',
            '🐆', '🦓', '🦍', '🦧', '🐘', '🦛', '🦏', '🐪', '🐫', '🦒',
            '🦘', '🦬', '🐃', '🐂', '🐄', '🐎', '🐖', '🐏', '🐑', '🦙',
            '🐐', '🦌', '🐕', '🐩', '🦮', '🐈', '🐈‍⬛', '🪶', '🐓', '🦃',
            '🦤', '🦚', '🦜', '🦢', '🦩', '🕊️', '🐇', '🦝', '🦨', '🦡',
            '🦫', '🦦', '🦥', '🐁', '🐀', '🐿️', '🦔', '🐉', '🐲',
        ],
    },
    food: {
        label: 'Еда',
        icon: '🍔',
        emojis: [
            '🍏', '🍎', '🍐', '🍊', '🍋', '🍌', '🍉', '🍇', '🍓', '🫐',
            '🍈', '🍒', '🍑', '🥭', '🍍', '🥥', '🥝', '🍅', '🍆', '🥑',
            '🥦', '🥬', '🥒', '🌶️', '🫑', '🌽', '🥕', '🫒', '🧄', '🧅',
            '🥔', '🍠', '🥐', '🥯', '🍞', '🥖', '🥨', '🧀', '🥚', '🍳',
            '🧈', '🥞', '🧇', '🥓', '🥩', '🍗', '🍖', '🦴', '🌭', '🍔',
            '🍟', '🍕', '🥪', '🥙', '🧆', '🌮', '🌯', '🫔', '🥗', '🥘',
            '🫕', '🥫', '🍝', '🍜', '🍲', '🍛', '🍣', '🍱', '🥟', '🦪',
            '🍤', '🍙', '🍚', '🍘', '🍥', '🥠', '🥮', '🍢', '🍡', '🍧',
            '🍨', '🍦', '🥧', '🧁', '🍰', '🎂', '🍮', '🍭', '🍬', '🍫',
            '🍿', '🍩', '🍪', '🌰', '🥜', '🍯', '🥛', '🍼', '🫖', '☕',
            '🍵', '🧃', '🥤', '🧋', '🍶', '🍺', '🍻', '🥂', '🍷', '🥃',
            '🍸', '🍹', '🧉', '🍾', '🧊', '🥄', '🍴', '🍽️', '🥣', '🥡',
            '🥢', '🧂',
        ],
    },
    activities: {
        label: 'Активности',
        icon: '⚽',
        emojis: [
            '⚽', '🏀', '🏈', '⚾', '🥎', '🎾', '🏐', '🏉', '🥏', '🎱',
            '🪀', '🏓', '🏸', '🏒', '🏑', '🥍', '🏏', '🪃', '🥅', '⛳',
            '🪁', '🏹', '🎣', '🤿', '🥊', '🥋', '🎽', '🛹', '🛼', '🛷',
            '⛸️', '🥌', '🎿', '⛷️', '🏂', '🪂', '🏋️', '🤼', '🤸', '⛹️',
            '🤺', '🤾', '🏌️', '🏇', '🧘', '🏄', '🏊', '🤽', '🚣', '🧗',
            '🚵', '🚴', '🏆', '🥇', '🥈', '🥉', '🏅', '🎖️', '🏵️', '🎗️',
            '🎫', '🎟️', '🎪', '🤹', '🎭', '🩰', '🎨', '🎬', '🎤', '🎧',
            '🎼', '🎵', '🎶', '🪘', '🥁', '🎷', '🪗', '🎸', '🎹', '🎺',
            '🎻', '🪕', '🥢', '🎲', '🧩', '♟️', '🎯', '🎳', '🎮', '🕹️',
            '🎰', '🧩',
        ],
    },
    travel: {
        label: 'Путешествия',
        icon: '✈️',
        emojis: [
            '🚗', '🚕', '🚙', '🚌', '🚎', '🏎️', '🚓', '🚑', '🚒', '🚐',
            '🛻', '🚚', '🚛', '🚜', '🦯', '🦽', '🦼', '🛴', '🚲', '🛵',
            '🏍️', '🛺', '🚨', '🚔', '🚍', '🚘', '🚖', '🚡', '🚠', '🚟',
            '🚃', '🚋', '🚞', '🚝', '🚄', '🚅', '🚈', '🚂', '🚆', '🚇',
            '🚊', '🚉', '✈️', '🛫', '🛬', '🛩️', '💺', '🛰️', '🚀', '🛸',
            '🚁', '🛶', '⛵', '🚤', '🛥️', '🛳️', '⛴️', '🚢', '⚓', '🪝',
            '⛽', '🚧', '🚦', '🚥', '🚏', '🗺️', '🗿', '🗽', '🗼', '🏰',
            '🏯', '🏟️', '🎡', '🎢', '🎠', '⛲', '⛱️', '🏖️', '🏝️', '🏜️',
            '🌋', '⛰️', '🏔️', '🗻', '🏕️', '⛺', '🛖', '🏠', '🏡', '🏘️',
            '🏚️', '🏗️', '🏭', '🏢', '🏬', '🏣', '🏤', '🏥', '🏦', '🏨',
            '🏪', '🏫', '🏩', '💒', '🏛️', '⛪', '🕌', '🛕', '🕍', '⛩️',
            '🕋', '🌁', '🌃', '🏙️', '🌅', '🌄', '🌞', '🌝', '🌛', '🌜',
            '🌗', '🌍', '🌎', '🌏', '🪐', '💫', '⭐', '🌟', '✨', '⚡',            '☄️', '💥', '🔥', '🌪️', '🌈', '☀️', '🌤️', '⛅', '🌥️', '☁️',
            '🌦️', '🌧️', '⛈️', '🌩️', '🌨️', '❄️', '☃️', '⛄', '🌬️', '💨',
            '💧', '💦', '☔', '☂️', '🌊', '🌫️',
        ],
    },
    objects: {
        label: 'Объекты',
        icon: '💡',
        emojis: [
            '⌚', '📱', '📲', '💻', '⌨️', '🖥️', '🖨️', '🖱️', '🖲️', '🕹️',
            '🗜️', '💽', '💾', '💿', '📀', '📼', '📷', '📸', '📹', '🎥',
            '📽️', '🎞️', '📞', '☎️', '📟', '📠', '📺', '📻', '🎙️', '🎚️',
            '🎛️', '🧭', '⏱️', '⏲️', '⏰', '🕰️', '⌛', '⏳', '📡', '🔋',
            '🔌', '💡', '🔦', '🕯️', '🪔', '🧯', '🛢️', '💸', '💵', '💴',
            '💶', '💷', '🪙', '💰', '💳', '💎', '⚖️', '🪜', '🧰', '🪛',
            '🔧', '🔨', '⚒️', '🛠️', '⛏️', '🪚', '🔩', '⚙️', '🪤', '🧱',
            '⛓️', '🧲', '🔫', '💣', '🧨', '🪓', '🔪', '🗡️', '⚔️', '🛡️',
            '🚬', '⚰️', '🪦', '⚱️', '🏺', '🔮', '📿', '🧿', '💈', '⚗️',
            '🔭', '🔬', '🕳️', '🩹', '🩺', '💊', '💉', '🩸', '🧬', '🦠',
            '🧫', '🧪', '🌡️', '🧹', '🧺', '🧻', '🚽', '🚰', '🚿', '🛁',
            '🛀', '🧼', '🪒', '🧽', '🪣', '🧴', '🛎️', '🔑', '🗝️', '🚪',
            '🪑', '🛋️', '🛏️', '🛌', '🧸', '🪆', '🖼️', '🪞', '🪟', '🛍️',
            '🛒', '🎁', '🎈', '🎏', '🎀', '🪄', '🎊', '🎉', '🎎', '🏮',
            '🎐', '🧧', '✉️', '📩', '📨', '📧', '💌', '📥', '📤', '📦',
            '🏷️', '🪧', '📪', '📫', '📬', '📭', '📮', '📯', '📜', '📃',
            '📄', '📑', '🧾', '📊', '📈', '📉', '🗒️', '🗓️', '📆', '📅',
            '🗑️', '📇', '🗃️', '🗳️', '🗄️', '📋', '📁', '📂', '🗂️', '🗞️',
            '📰', '📓', '📔', '📒', '📕', '📗', '📘', '📙', '📚', '📖',
            '🔖', '🧷', '🔗', '📎', '🖇️', '📐', '📏', '🧮', '📌', '📍',
            '✂️', '🖊️', '🖋️', '✒️', '🖌️', '🖍️', '📝', '✏️', '🔍', '🔎',
            '🔐', '🔒', '🔓',
        ],
    },
    symbols: {
        label: 'Символы',
        icon: '🔣',
        emojis: [
            '🚫', '⛔', '🚷', '🚯', '🚳', '🚱', '🚭', '🔞', '📵', '🚭',
            '❌', '⭕', '🛑', '⛔', '✔️', '✅', '☑️', '❎', '➕', '➖',
            '➗', '✖️', '🟰', '♾️', '💲', '💱', '❓', '❔', '❕', '❗',
            '‼️', '⁉️', '🔅', '🔆', '〽️', '⚠️', '🚸', '🔱', '⚜️', '🔰',
            '♻️', '✅', '🈯', '💹', '❇️', '✳️', '❎', '🌐', '💠', 'Ⓜ️',
            '🌀', '💤', '🏧', '🚾', '♿', '🅿️', '🈳', '🈂️', '🛂', '🛃',
            '🛄', '🛅', '🚹', '🚺', '🚼', '🚻', '🚮', '🎦', '📶', '🈁',
            '🔣', '🔤', '🔡', '🔠', '🆖', '🆗', '🆙', '🆒', '🆕', '🆓',
            '0️⃣', '1️⃣', '2️⃣', '3️⃣', '4️⃣', '5️⃣', '6️⃣', '7️⃣', '8️⃣', '9️⃣',
            '🔟', '🔢', '#️⃣', '*️⃣', '⏏️', '▶️', '⏸️', '⏯️', '⏹️', '⏺️',
            '⏭️', '⏮️', '⏩', '⏪', '⏫', '⏬', '◀️', '🔼', '🔽', '➡️',
            '⬅️', '⬆️', '⬇️', '↗️', '↘️', '↙️', '↖️', '↕️', '↔️', '↪️',
            '↩️', '⤴️', '⤵️', '🔀', '🔁', '🔂', '🔄', '🔃', '🎵', '🎶',
            '➕', '➖', '➗', '✖️', '🟰', '♾️', '💲', '💱', '🔴', '🟠',
            '🟡', '🟢', '🔵', '🟣', '🟤', '⚫', '⚪', '🟥', '🟧', '🟨',
            '🟩', '🟦', '🟪', '🟫', '⬛', '⬜', '◼️', '◻️', '◾', '◽',
            '▪️', '▫️', '🔶', '🔷', '🔸', '🔹', '🔺', '🔻', '💠', '🔘',
            '🔳', '🔲',
        ],
    },
    flags: {
        label: 'Флаги',
        icon: '🇷🇺',
        emojis: [
            '🇷🇺', '🇧🇾', '🇺🇦', '🇰🇿', '🇺🇸', '🇬🇧', '🇫🇷', '🇩🇪', '🇮🇹', '🇪🇸',
            '🇵🇹', '🇳🇱', '🇧🇪', '🇨🇭', '🇦🇹', '🇸🇪', '🇳🇴', '🇩🇰', '🇫🇮', '🇮🇸',
            '🇵🇱', '🇨🇿', '🇸🇰', '🇭🇺', '🇷🇴', '🇧🇬', '🇬🇷', '🇷🇸', '🇭🇷', '🇸🇮',
            '🇧🇦', '🇲🇰', '🇦🇱', '🇱🇻', '🇱🇹', '🇪🇪', '🇲🇩', '🇦🇲', '🇦🇿', '🇬🇪',
            '🇹🇷', '🇨🇳', '🇯🇵', '🇰🇷', '🇻🇳', '🇹🇭', '🇮🇳', '🇮🇩', '🇲🇾', '🇸🇬',
            '🇵🇭', '🇦🇺', '🇳🇿', '🇨🇦', '🇲🇽', '🇧🇷', '🇦🇷', '🇨🇱', '🇵🇪', '🇨🇴',
            '🇿🇦', '🇪🇬', '🇲🇦', '🇳🇬', '🇰🇪', '🇸🇦', '🇦🇪', '🇮🇱', '🇮🇷', '🇮🇶',
            '🇪🇺', '🇺🇳', '🏳️', '🏴', '🏁', '🚩',
        ],
    },
};

const CATEGORY_ORDER = ['smileys', 'gestures', 'hearts', 'animals', 'food', 'activities', 'travel', 'objects', 'symbols', 'flags'];

const RECENT_STORAGE_KEY = 'hrnb:emoji-recent';
const MAX_RECENT = 32;

/**
 * Загружает недавно использованные эмодзи из localStorage.
 * @returns {string[]}
 */
function loadRecentEmojis() {
    try {
        const stored = localStorage.getItem(RECENT_STORAGE_KEY);
        if (stored) {
            const parsed = JSON.parse(stored);
            if (Array.isArray(parsed)) return parsed;
        }
    } catch { /* noop */ }
    return [];
}

/**
 * Сохраняет список недавно использованных эмодзи в localStorage.
 * @param {string[]} emojis
 */
function saveRecentEmojis(emojis) {
    try {
        localStorage.setItem(RECENT_STORAGE_KEY, JSON.stringify(emojis));
    } catch { /* noop */ }
}

/**
 * Добавляет эмодзи в начало списка недавно использованных,
 * удаляя дубликаты и ограничивая длину.
 * @param {string[]} recent - Текущий список
 * @param {string} emoji - Новый эмодзи
 * @returns {string[]} Обновлённый список
 */
function addToRecent(recent, emoji) {
    const filtered = recent.filter(e => e !== emoji);
    return [emoji, ...filtered].slice(0, MAX_RECENT);
}

/**
 * Панель выбора эмодзи с категориями, поиском и недавно использованными.
 *
 * Рендерится через portal в document.body с фиксированным позиционированием
 * относительно anchor-элемента. Динамически вычисляет позицию, чтобы
 * не выходить за пределы viewport (переключается сверху/снизу, сдвигается
 * по горизонтали).
 *
 * Используется в двух режимах:
 * - reaction: для реакций на сообщения (с панелью быстрых реакций сверху)
 * - input: для вставки эмодзи в текстовое поле сообщения
 *
 * @param {React.RefObject} anchorRef - Ref на элемент-якорь (кнопка, открывшая пикер)
 * @param {Function} onSelect - Колбэк при выборе эмодзи: (emoji) => void
 * @param {Function} [onClose] - Колбэк при закрытии пикера
 * @param {('reaction'|'input')} [mode='input'] - Режим работы
 * @param {string[]} [quickReactions] - Эмодзи для панели быстрых реакций (mode='reaction')
 * @param {string} [className] - Дополнительные CSS-классы
 */
export default function EmojiPicker({
    anchorRef,
    onSelect,
    onClose,
    mode = 'input',
    quickReactions = [],
    className = '',
}) {
    const [activeCategory, setActiveCategory] = useState('recent');
    const [search, setSearch] = useState('');
    const [recent, setRecent] = useState(loadRecentEmojis);
    const [coords, setCoords] = useState(null); // { top, left } фиксированные координаты
    const containerRef = useRef(null);
    const searchInputRef = useRef(null);
    const gridRef = useRef(null);

    const PICKER_WIDTH = 320;
    const GAP = 8;
    const MARGIN = 8;

    /**
     * Вычисляет фиксированные координаты пикера относительно anchor-элемента,
     * гарантируя что пикер не выйдет за пределы viewport.
     */
    const computePosition = useCallback(() => {
        const anchor = anchorRef?.current;
        if (!anchor) return null;

        const rect = anchor.getBoundingClientRect();
        const pickerEl = containerRef.current;
        // Реальная высота пикера (если уже отрендерен), иначе fallback
        const pickerHeight = pickerEl ? pickerEl.offsetHeight : 360;
        const vw = window.innerWidth;
        const vh = window.innerHeight;

        const spaceAbove = rect.top;
        const spaceBelow = vh - rect.bottom;

        // Вертикаль: предпочитаем сверху, если не помещается — снизу,
        // если ни там ни там — открываем где больше места
        let top;
        if (spaceAbove >= pickerHeight + GAP) {
            top = rect.top - pickerHeight - GAP;
        } else if (spaceBelow >= pickerHeight + GAP) {
            top = rect.bottom + GAP;
        } else if (spaceAbove >= spaceBelow) {
            // Больше места сверху — прижимаем к верхнему краю viewport
            top = MARGIN;
        } else {
            // Больше места снизу — прижимаем к нижнему краю
            top = Math.max(MARGIN, vh - pickerHeight - MARGIN);
        }

        // Горизонталь: выравниваем по левому краю якоря, при выходе за
        // правый край — сдвигаем влево, при выходе за левый — прижимаем
        let left = rect.left;
        if (left + PICKER_WIDTH > vw - MARGIN) {
            left = vw - PICKER_WIDTH - MARGIN;
        }
        if (left < MARGIN) left = MARGIN;

        return { top, left };
    }, [anchorRef]);

    // Вычисляем позицию до отрисовки (первый проход) и при изменении якоря
    useLayoutEffect(() => {
        const pos = computePosition();
        setCoords(pos);
    }, [computePosition]);

    // После того как coords установлены и пикер виден — пересчитываем с
    // реальной измеренной высотой (первый проход использует fallback 360)
    useLayoutEffect(() => {
        if (coords === null) return;
        const pos = computePosition();
        if (pos) setCoords(pos);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [coords === null]);

    // Пересчёт позиции при scroll (включая вложенные скролл-контейнеры) и resize
    useEffect(() => {
        const handle = () => {
            const pos = computePosition();
            if (pos) setCoords(pos);
        };
        window.addEventListener('scroll', handle, { capture: true, passive: true });
        window.addEventListener('resize', handle);
        return () => {
            window.removeEventListener('scroll', handle, { capture: true, passive: true });
            window.removeEventListener('resize', handle);
        };
    }, [computePosition]);

    // Фокус на поле поиска при открытии
    useEffect(() => {
        searchInputRef.current?.focus();
    }, []);

    // Обработка клика вне пикера и Escape для закрытия
    useEffect(() => {
        if (!onClose) return;
        const handlePointerDown = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                onClose();
            }
        };
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                e.stopPropagation();
                onClose();
            }
        };
        // Небольшая задержка, чтобы не закрыть тем же кликом, что открыл
        const timer = setTimeout(() => {
            document.addEventListener('mousedown', handlePointerDown);
            document.addEventListener('touchstart', handlePointerDown);
            document.addEventListener('keydown', handleKeyDown);
        }, 0);
        return () => {
            clearTimeout(timer);
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('touchstart', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose]);

    /**
     * Обработка выбора эмодзи: обновляет recent и вызывает onSelect.
     */
    const handleSelect = useCallback((emoji) => {
        const updated = addToRecent(recent, emoji);
        setRecent(updated);
        saveRecentEmojis(updated);
        onSelect?.(emoji);
    }, [recent, onSelect]);

    /**
     * Фильтрация эмодзи по поисковому запросу.
     * Поиск выполняется по всем категориям одновременно.
     */
    const searchResults = useMemo(() => {
        if (!search.trim()) return null;
        const query = search.trim().toLowerCase();
        const results = [];
        for (const catKey of CATEGORY_ORDER) {
            const cat = EMOJI_CATEGORIES[catKey];
            for (const emoji of cat.emojis) {
                // Простой поиск: совпадение по категории
                if (cat.label.toLowerCase().includes(query)) {
                    results.push(emoji);
                }
            }
        }
        // Дедупликация
        return [...new Set(results)];
    }, [search]);

    /**
     * Эмодзи для отображения в текущей активной категории.
     */
    const currentEmojis = useMemo(() => {
        if (searchResults) return searchResults;
        if (activeCategory === 'recent') return recent;
        return EMOJI_CATEGORIES[activeCategory]?.emojis || [];
    }, [searchResults, activeCategory, recent]);

    /**
     * Доступные вкладки категорий (включая "Недавние", если есть recent).
     */
    const tabs = useMemo(() => {
        const tabsList = [];
        if (recent.length > 0 && !search.trim()) {
            tabsList.push({ key: 'recent', icon: '🕘', label: 'Недавние' });
        }
        for (const catKey of CATEGORY_ORDER) {
            const cat = EMOJI_CATEGORIES[catKey];
            tabsList.push({ key: catKey, icon: cat.icon, label: cat.label });
        }
        return tabsList;
    }, [recent, search]);

    const pickerStyle = coords
        ? { position: 'fixed', top: `${coords.top}px`, left: `${coords.left}px` }
        : { position: 'fixed', top: 0, left: 0, visibility: 'hidden' };

    return createPortal(
        <div
            ref={containerRef}
            className={`emoji-picker ${mode === 'reaction' ? 'emoji-picker--reaction' : ''} ${className}`}
            style={pickerStyle}
        >
            {/* Панель быстрых реакций (только в режиме reaction) */}
            {mode === 'reaction' && quickReactions.length > 0 && (
                <div className="emoji-picker__quick-reactions">
                    {quickReactions.map(emoji => (
                        <button
                            key={emoji}
                            type="button"
                            className="emoji-picker__quick-btn"
                            onClick={() => handleSelect(emoji)}
                            title={emoji}
                        >
                            {emoji}
                        </button>
                    ))}
                </div>
            )}

            {/* Поиск */}
            <div className="emoji-picker__search">
                <input
                    ref={searchInputRef}
                    type="text"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    placeholder="Поиск эмодзи..."
                    className="emoji-picker__search-input"
                />
                {search && (
                    <button
                        type="button"
                        className="emoji-picker__search-clear"
                        onClick={() => setSearch('')}
                        title="Очистить"
                    >
                        ✕
                    </button>
                )}
            </div>

            {/* Сетка эмодзи */}
            <div ref={gridRef} className="emoji-picker__grid">
                {currentEmojis.length === 0 ? (
                    <div className="emoji-picker__empty">
                        {search.trim()
                            ? 'Ничего не найдено'
                            : 'Здесь появятся недавно использованные эмодзи'}
                    </div>
                ) : (
                    currentEmojis.map((emoji, idx) => (
                        <button
                            key={`${emoji}-${idx}`}
                            type="button"
                            className="emoji-picker__emoji"
                            onClick={() => handleSelect(emoji)}
                            title={emoji}
                        >
                            {emoji}
                        </button>
                    ))
                )}
            </div>

            {/* Вкладки категорий */}
            {!search.trim() && (
                <div className="emoji-picker__categories">
                    {tabs.map(tab => (
                        <button
                            key={tab.key}
                            type="button"
                            className={`emoji-picker__category ${activeCategory === tab.key ? 'emoji-picker__category--active' : ''}`}
                            onClick={() => setActiveCategory(tab.key)}
                            title={tab.label}
                        >
                            {tab.icon}
                        </button>
                    ))}
                </div>
            )}
        </div>,
        document.body
    );
}
